import { useTranslation } from "react-i18next";
import { namespaces } from "../i18n.costants";
import { FullBleedCard } from './FullBleedCard';
import React from "react";
import styled from "styled-components";
import {GeneralText} from "./GeneralText";

export function AboutUsCard() {
  const { t } = useTranslation(namespaces.common);

  return (
  <FullBleedCard
    id={t("nav/about-us")}
    header={t("Perché scegliere noi")}
    title={t("Un servizio completo per chi ristruttura")}
  >
  <ReasonContainer>
    <Reason>
      <Title>{t("__Noi_ragione_1_titolo__")}</Title>
      <p>{t("__Noi_ragione_1__")}</p>
    </Reason>
    <Reason>
      <Title>{t("__Noi_ragione_2_titolo__")}</Title>
      <p>{t("__Noi_ragione_2__")}</p>
    </Reason>
    <Reason>
      <Title>{t("__Noi_ragione_3_titolo__")}</Title>
      <p>{t("__Noi_ragione_3_p1__")}</p>
      <br/>
      <p>{t("__Noi_ragione_3_p2__")}</p>
      <br/>
      <p>{t("__Noi_ragione_3_p3__")}</p>
    </Reason>
  </ReasonContainer>

  </FullBleedCard>
  )
}

const ReasonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--gap);
`;
const Reason = styled(GeneralText)`
  margin-block: 0.5rem;
  text-align: left;
`;

const Title = styled(GeneralText)`
  font-weight: bold;
  margin-bottom: 0.5rem;
  text-align: left;
`;
